/**
 * Subscription Constants
 * Centralized configuration for subscription-related values
 */

// Grace period duration in days
export const GRACE_PERIOD_DAYS = 3;

// Stripe public key
export const STRIPE_PUBLIC_KEY = 'pk_live_51RMXEKKOkMYMdOt6IHJmKve3IHjWP3DwSiJDfRgOI5rvV7sxtlva890d7jvj6LiadeZ6Pj1J8WYav7kTrrEsnjFy00Fg5DKNcB';

// API endpoints
export const API_ENDPOINTS = {
    STATUS: '/api/v1/subscription/status',
    PRODUCTS: '/api/v1/subscription/products',
    CREATE_CHECKOUT: '/api/v1/subscription/create-checkout-session',
    CHANGE_PLAN: '/api/v1/subscription/change-plan',
    CANCEL: '/api/v1/subscription/cancel',
    CUSTOMER_PORTAL: '/api/v1/subscription/customer-portal',
    START_TRIAL: '/api/v1/subscription/start-trial'
};

// Subscription statuses
export const SUBSCRIPTION_STATUS = {
    ACTIVE: 'ACTIVE',
    TRIAL: 'TRIAL',
    EXPIRED: 'EXPIRED',
    CANCELED: 'CANCELED',
    UNPAID: 'UNPAID',
    PAUSED: 'PAUSED',
    NONE: 'NONE',
    NOT_FOUND: 'NOT_FOUND',
    ERROR: 'ERROR'
};

// User types
export const USER_TYPE = {
    TRAINER: 'TRAINER',
    OWNER: 'OWNER'
};

// Public paths where subscription modal shouldn't show
export const PUBLIC_PATHS = ['/', '/login', '/forgot-password', '/register'];

// Subscription-related paths
export const SUBSCRIPTION_PATHS = ['/subscription/plans', '/subscription/success', '/subscription/cancel'];

// Support email
export const SUPPORT_EMAIL = 'support@dogoapp.com';

// Redirect countdown duration in seconds
export const REDIRECT_COUNTDOWN = 10;
